import React, { useRef, Children } from 'react';
import { motion, useInView } from 'framer-motion';
interface AnimatedSectionProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  staggerChildren?: boolean;
}
export function AnimatedSection({
  children,
  className = '',
  delay = 0,
  staggerChildren = false
}: AnimatedSectionProps) {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px 0px'
  });
  const containerVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut',
        delay: delay,
        when: 'beforeChildren',
        staggerChildren: staggerChildren ? 0.15 : 0
      }
    }
  };
  return <motion.section ref={ref} variants={containerVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} className={className} data-id="element-1">
      {children}
    </motion.section>;
}
export const AnimatedItem = ({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <motion.div variants={itemVariants} className={className} data-id="element-2">
      {children}
    </motion.div>;
};